document.addEventListener("DOMContentLoaded", function () {
    function isInAppBrowser() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return (
            ua.includes("FBAN") || ua.includes("FBAV") ||
            ua.includes("Instagram") || ua.includes("TikTok") ||
            ua.includes("Twitter") || ua.includes("Snapchat")
        );
    }

    if (isInAppBrowser() && !sessionStorage.getItem("inAppClosed")) {
        const message = {
            en: "For a better experience, please open this site in your browser.",
            fr: "Pour une meilleure expérience, veuillez ouvrir ce site dans votre navigateur.",
            nl: "Voor een betere ervaring, open deze site in uw browser.",
            ru: "Для лучшего опыта откройте этот сайт в вашем браузере."
        };

        const buttonText = {
            en: "Open in Browser",
            fr: "Ouvrir dans le navigateur",
            nl: "Openen in browser",
            ru: "Открыть в браузере"
        };

        const iosExtra = {
            en: "On iPhone: Tap ⋯ in the top-right corner and select <b>Open in Browser</b>.",
            fr: "Sur iPhone : Appuyez sur ⋯ en haut à droite, puis sélectionnez <b>Ouvrir dans le navigateur</b>.",
            nl: "Op iPhone: Tik rechtsboven op ⋯ en kies <b>Openen in browser</b>.",
            ru: "На iPhone: Нажмите ⋯ в правом верхнем углу и выберите <b>Открыть в браузере</b>."
        };

        const siteLang = document.documentElement.lang || "en";
        let lang = siteLang.substring(0, 2);
        if (!["en", "fr", "nl", "ru"].includes(lang)) {
            lang = "en";
        }

        const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
        const isAndroid = /android/i.test(navigator.userAgent);

        const div = document.createElement("div");
        div.innerHTML = `
            <div id="inAppWarning" style="
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                background: rgba(0, 0, 0, 0.95);
                color: white;
                padding: 15px;
                text-align: center;
                font-size: 16px;
                z-index: 10000000000;
                box-shadow: 0px -4px 10px rgba(0,0,0,0.2);
                display: flex;
                flex-direction: column;
                align-items: center;
            ">
                <button id="closeInAppWarning" style="
    position: absolute;
    bottom: 25px;
    right: 10px;
    background: transparent;
    color: white;
    border: 1px solid white;
    padding: 2px 8px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s ease;
">×</button>

                <p style="margin: 0 0 10px;">${message[lang]}</p>
                ${isAndroid ? `
                    <button id="openBrowserBtn" style="
                        background-color: #ffcc00;
                        border: none;
                        padding: 10px 20px;
                        font-size: 16px;
                        font-weight: bold;
                        cursor: pointer;
                        border-radius: 5px;
                        margin-bottom: 8px;
                    ">${buttonText[lang]}</button>
                ` : ""}
                ${isIOS ? `<p style="font-size: 14px; opacity: 0.9;">${iosExtra[lang]}</p>` : ""}
            </div>
        `;
        document.body.appendChild(div);

        // Android: кнопка открытия в Chrome
        if (isAndroid) {
            document.getElementById("openBrowserBtn").addEventListener("click", function () {
                const url = window.location.href;
                window.location = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end;`;
            });
        }

        // Крестик закрытия
        document.getElementById("closeInAppWarning").addEventListener("click", function () {
            document.getElementById("inAppWarning").remove();
            sessionStorage.setItem("inAppClosed", "1");
        });
    }
});
